import type { ReactElement } from 'react';
/**
 * A content-shaped placeholder. Decorative, so it is hidden from assistive tech.
 *
 * The animation is `.shimmer` (globals.css) rather than `animate-pulse`, so
 * every loading surface in the app — this, the table's skeleton cells, the
 * dashboard tiles — moves in exactly one way. A page where three different
 * things are pulsing at three different rhythms reads as broken rather than
 * busy. `prefers-reduced-motion` caps it globally at 0.01ms, so there is no
 * per-component opt-out to forget.
 */
export function Skeleton({ className = 'h-4 w-full' }: { className?: string }): ReactElement {
  return <div aria-hidden="true" className={`shimmer rounded-[var(--radius-sm)] ${className}`} />;
}
